



















import EventCardLabel from '@shared/event/EventCardLabel.vue';
import { formatDisplayDateTime } from '@superbet-group/web.lib.vue-utilities';
import {
    computed,
    defineComponent,
} from '@vue/composition-api';
export default defineComponent({
    name: 'TicketEventCondensed',
    props: {
        teamNameOne: {
            type: String,
            required: true,
        },
        teamNameTwo: {
            type: String,
            required: false,
            default: undefined,
        },
        date: {
            type: Date,
            required: true,
        },
    },
    setup(props) {
        const formattedDate = computed(() => formatDisplayDateTime(props.date));
        return {
            formattedDate,
        };
    },
    components: {
        EventCardLabel,
    },
});
